import React from 'react';
import { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Button,
    Modal
} from '@mui/material';
import {
    DataGrid
} from '@mui/x-data-grid';
import RulerNotesModal from '../rulers/RulerInfoModal';
import { useRulersForCompany } from '../../hooks/useRulers';
import { useAdminCompany } from '../../context/AdminCompanyContext';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const CompanyRulerDataGrid = () => {
    /// Company data grid for super admins shows all registered companies
    const [open, setOpen] = React.useState(false);
    const [check, setCheck] = React.useState(false);
    const { companyData } = useAdminCompany();
    const { data: allRulers = [] } = useRulersForCompany({
        companyId: companyData?.id,
        enabled: Boolean(companyData?.id),
    });
    const [rowItem, setRowItem] = useState();
    const [open1, setOpen1] = React.useState(false);
    const handleOpen1 = () => setOpen1(true);
    const handleClose1 = () => setOpen1(false);
    const [open2, setOpen2] = React.useState(false);
    const handleClose2 = () => setOpen2(false);

    function showInfo(cellValues) { // hadles the double click to bring up modal to edit crop amount
        setRowItem({
            id: cellValues.row.id,
            rulerNotes: cellValues.row.rulerNotes,
            rulerSerialNumber: cellValues.row.rulerSerialNumber,
            userId: cellValues.row.companyId,
            warrantyDate: cellValues.row.warrantyDate
        })
        handleOpen1();
    };

    const columns = [
        { field: 'rulerSerialNumber', headerName: 'Ruler#', width: 250, headerClassName: 'header' },
        { field: 'companyName', headerName: 'Company', width: 200, headerClassName:'header',
            renderCell: (cellValues) => {
                if(cellValues.row.companyName){
                    return(<span>{cellValues.row.companyName}</span>)
                } else {
                    return(<span>N/A</span>)
                }
            }
        },
        { field: 'warrantyDate', headerName: 'Warranty', width: 150, headerClassName:'header',
            renderCell: (cellValues) => {
                let date = new Date(cellValues.row.warrantyDate);
                if(cellValues.row.warrantyDate){
                    return(<span onClick={() => editRulerDate(cellValues)}>{date.toLocaleDateString()}</span>)
                } else {
                    return(<span onClick={() => editRulerDate(cellValues)}>N/A</span>)
                }
            }
        },
        { field: 'rulerNotes', headerName: 'Notes', width: 250, headerClassName: 'header',
            renderCell: (cellValues) => {
                if(cellValues.row.rulerNotes){
                    return(<Button onClick={() => showInfo(cellValues)} style={{justifyContent:'flex-start', overflow: 'hidden', textOverflow: 'ellipsis', }}>{cellValues.row.rulerNotes}</Button>)
                } else {
                    return(<Button onClick={() => showInfo(cellValues)} style={{justifyContent:'flex-start', overflow: 'hidden', textOverflow: 'ellipsis'}}>No Notes</Button>)
                }
            }
        }
    ];

    const handleOpen = () => setOpen(!open);
    const handleCheck = () => setCheck(!check);

    useEffect(() => {
    }, []);

    return (
        <div>
            <Box p={3} sx={{ '& .header': { backgroundColor: '#e2e2e2' } }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant='h3' textAlign='left' p={2}>
                        Rulers
                    </Typography>
                </Box>
                <DataGrid
                    columns={columns}
                    rows={allRulers}
                    style={{textAlign:'left', height:'70vh'}}
                />
                <Modal
                    open={open1}
                    onClose={handleClose1}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <RulerNotesModal updateType={1} item={rowItem} style={style} handleClose1={handleClose1} handleClose2={handleClose2}/>
                </Modal>
            </Box>
        </div>
    )
};

export default CompanyRulerDataGrid;